import { pattern, prop, required } from "@rxweb/reactive-form-validators";

export class SeoInfoFormControl {
    @prop()
    seoInfoId: number = 0;
    @prop()
    primarySeoInfo:boolean;
    @prop()
    displayName: string;
    @prop()
    title: string;
    @prop()
    description: string;
    @prop()
    keywords: string;

    @required()
    @pattern({ expression: { url: /^[a-zA-Z0-9]+([- ]?[a-zA-Z0-9]+)*$/ }, message: 'This field cannot have any char different than alphabet and number!' })
    friendlyUrl: string;
    @prop()
    primaryKeyword:string;
    @prop()
    secondaryKeyword: string;
    @prop()
    noIndex: boolean = false;
}
// 2021-10-01 tien add start
export class SeoInfoModel {
    // tslint:disable-next-line:no-inferrable-types
    seoInfoId: number = 0;
    title: string;
    description: string;
    keywords: string;
    friendlyUrl: string;
    noIndex: boolean = false;
}
// 2021-10-01 tien add end
